module.exports = __webpack_public_path__ + "images/icon-app.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-app.png
// module id = 841
// module chunks = 106